import * as React from 'react';
import { Col, FormGroup, ControlLabel, Form, Button } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { isRequired } from '../../../../../../util/validators';

interface ICreateAnAccountFormProps {
  actions: {
    push: (route: string) => void;
  };
}

class CreateAnAccountForm extends React.Component<ICreateAnAccountFormProps> {
  public render() {
    const { handleSubmit } = this.props;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div className="blue-section-group">
          <div className="blue-section">
            <FormGroup controlId="name">
              <Col componentClass={ControlLabel} sm={3}>
                Name
              </Col>
              <Col sm={5}>
                <Field
                  name={'firtName'}
                  type="text"
                  placeholder="First Name"
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
              <Col sm={4}>
                <Field
                  name={`lastName`}
                  type="text"
                  placeholder="Last Name"
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
          </div>
          <div className="blue-section">
            <FormGroup controlId="dob">
              <Col componentClass={ControlLabel} sm={3}>
                Date of Birth
              </Col>
              <Col sm={4}>
                <Field
                  name={'dob'}
                  type="masked-date"
                  component={FieldFormControl}
                  placeholder="dd/mm/yyyy"
                  className="form-control"
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
          </div>
          <div className="blue-section">
            <FormGroup controlId="email">
              <Col componentClass={ControlLabel} sm={3}>
                Email
              </Col>
              <Col sm={5}>
                <Field
                  name={'email'}
                  type="email"
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
          </div>
        </div>
        <div className="btn-bar">
          <div className="link-back">
            <Link to="/auth/login" className="pull-left">
              Back
            </Link>
          </div>
          <Button
            bsStyle="primary"
            type="submit"
            className="pull-right btn-remove-border"
          >
            ACTIVATE MY ACCOUNT
          </Button>
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'forgotten_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('forgotten_password');

    return component;
  },
  connect(
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(CreateAnAccountForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/CreateAnAccount/components/CreateAnAccountForm/index.tsx